import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { PendientesCargaDescarga as Comp } from "app/features/componentes/cargas";
export interface Props {
    /**Id de la carga/descarga */
    idCargaDescargaEAD: number;
}

/**Dado el idCargaDescarga muestra los sobres y paquetes pendientesk */
export class PendientesCargaDescarga extends React.PureComponent<Props> {
    idCargaDescarga = (props: Props) => props.idCargaDescargaEAD;
    pendientes = createSelectorRx(this.idCargaDescarga, idCargaDescarga => observeResource(resources.CargaDescargaEAD.ObtenerServiciosPendientes, idCargaDescarga));

    onQuitarPaquete = async (x: models.PaquetePendienteDto) => {
        const idCarga = this.props.idCargaDescargaEAD;
        await resources.CargaDescargaEAD.QuitarPaqueteIncompleto(idCarga, x.IdServicio, x.NumeroFisico);
    }


    onQuitarSobre = async (x: models.SobrePendienteDto) => {
        const idCarga = this.props.idCargaDescargaEAD;
        await resources.CargaDescargaEAD.QuitarSobreIncompleto(idCarga, x.IdServicio, x.NumeroFisico);
    }

    render() {
        const val = this.pendientes(this.props);
        return <Comp value={val} onQuitarPaquete={this.onQuitarPaquete} onQuitarSobre={this.onQuitarSobre} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasEAD/edit/estatus/items/pendientes.tsx